import { FC } from 'react';

import { DrawerProps } from 'antd/es/drawer';

import { CustomIcon } from '@components/Dropdown/styled';
import { CloseIcon } from '@assets/icons';

import { StyledDrawer } from './DrawerStyle';

const Drawer: FC<DrawerProps> = ({
  open,
  onClose,
  title = '',
  children,
  ...otherProps
}) => {
  return (
    <StyledDrawer
      title={title}
      closeIcon={
        <CustomIcon
          icon={CloseIcon}
          fontSize={24}
          paletteColor='whiteAlpha600'
        />
      }
      onClose={onClose}
      open={open}
      destroyOnHidden={true}
      styles={{
        wrapper: {
          height: '100%',
          width: '100%',
        },
      }}
      {...otherProps}
    >
      {children}
    </StyledDrawer>
  );
};

export default Drawer;
